<template>
    <v-dialog v-model="open" persistent max-width="80vw">
        <v-card>
            <v-card-title>
                <span class="headline">Compare with ELEOS</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="6">
                            <v-card>
                                <v-card-title>
                                    <span class="headline">Order Details</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                label="Order ID"
                                                v-model="order.OrderID"
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Order Date"
                                                v-model="order.ShiftDetail"
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Order Status"
                                                v-model="order.OrderStatus"
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Shift Detail"
                                                v-model="order.ShiftDetail"
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Load Number"
                                                v-model="order.LoadNum"
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Load Status"
                                                v-model="order.OrdLoadStatus"
                                                readonly
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="6">
                            <v-card>
                                <v-card-title>
                                    <span class="headline"
                                        >ELEOS Order Details</span
                                    >
                                </v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                label="Order ID"
                                                v-model="
                                                    order.eleos_order.OrderID
                                                "
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Order Date"
                                                v-model="order.eleos_order.Date"
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Order Status"
                                                v-model="
                                                    order.eleos_order
                                                        .OrderStatus
                                                "
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Load Number"
                                                v-model="
                                                    order.eleos_order.LoadNum
                                                "
                                                readonly
                                            ></v-text-field>
                                            <v-text-field
                                                label="Load Status"
                                                v-model="
                                                    order.eleos_order.LoadStatus
                                                "
                                                readonly
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'CompareWithELEOS',
    props: {
        dialogStatus: {
            type: Boolean,
            default: false
        },
        order: {
            type: Object,
            default: () => ({})
            /**
             * Order sample:
             * {
"OrderID":
902347,
"OrderStatus":
"DISPATCHED",
"ShiftDetail":
375427,
"Customer":
423,
"Station":
2207,
"Terminal":
7,
"Supplier":
6,
"LoadingNumber":
"313783 PO 852690",
"PersonOrdering":
null,
"DateOrdered":
"2024-01-03 00:00:00",
"TimeOrdered":
"17:33:00",
"SpecialInstructions":
null,
"DateRequested":
null,
"TimeRequested":
null,
"DateTerminalPick":
null,
"TimeTerminalPick":
null,
"DateDelivered":
null,
"TimeDelivered":
null,
"BillOfLading":
null,
"LoadNum":
3,
"LoadNumOrd":
null,
"DispatchTime":
null,
"DispatchShift":
null,
"DispatchDate":
null,
"isPreload":
0,
"ReadyForDispatch":
1,
"RetainedOrder":
null,
"TempSurpress":
0,
"Employee":
"76",
"HoursETA":
null,
"ETATime":
"2024-01-04 12:04:21",
"PreloadOrderID":
0,
"BackColour":
0,
"InvoiceReqst":
0,
"LeadOrder":
null,
"InvLeadOrder":
null,
"TransactedInv":
0,
"TransactDateInv":
null,
"TransactedPay":
0,
"TransactDatePay":
null,
"ROHrs":
78,
"RODays":
0,
"TStart":
"2024-01-04 06:31:32",
"TEnd":
"2024-01-04 07:06:38",
"StStart":
"2024-01-04 07:40:41",
"StEnd":
"2024-01-04 08:11:27",
"ROTime":
"2024-01-07 22:49:49",
"RTTime":
"2024-01-04 07:45:00",
"GPS Comments":
null,
"RTHrs":
"16.0000",
"AdmComments":
null,
"GoalPost":
"0.0000",
"DynRTDttm":
null,
"DynRODttm":
null,
"DynETADttm":
null,
"DynGoalPost":
null,
"DispatchComments":
null,
"hasNoAllocation":
0,
"audDispatchedUsername":
null,
"audDispatchedDttm":
null,
"L1Initial":
0,
"L2Initial":
0,
"BrandID":
null,
"audRegDttm":
null,
"hasPosted":
0,
"PostedDttm":
null,
"PostedUsername":
null,
"SplitTypeID":
null,
"NoLoadTypeID":
null,
"OrderTypeID":
null,
"ShipTo":
null,
"SafeDischargeSheet":
null,
"ppwBOL":
0,
"ppwCTI":
0,
"ppwSDC":
0,
"isSpecific":
0,
"dropped":
null,
"NoAllocation":
null,
"Justify":
null,
"Diff":
null,
"OrdActiveOrder":
0,
"OrdLoadStatus":
"DONE",
"UnknownOrigins":
null,
"Finalize":
1,
"Validate":
0,
"PAS":
0,
"Transacted":
0,
"RetainHrs":
null,
"ROHrsDate":
null,
"ROHrsTime":
null,
"ReadyToTransact":
1,
"ActionId":
null,
"BolCheckStatusID":
1,
"ShortLoad":
null,
"AutomaticCreation":
null,
"TStartOrigin":
2,
"TEndOrigin":
2,
"StStartOrigin":
2,
"StEndOrigin":
2,
"GoalPostTime":
null,
"EndTripBelowAvg":
null,
"EndTripEvent":
null,
"eleos_order":
{
"ShiftHeaderNum":
13725,
"ShiftDetail":
375427,
"Date":
"2024-01-04",
"Shift":
"AM",
"DriverID":
643,
"DriverName":
"RANDHAWA, GURPARLAD",
"ActiveOrder":
0,
"OrderID":
902347,
"OrderStatus":
"DISPATCHED",
"LoadStatus":
"DONE",
"TempLoadStatus":
"DONE",
"LoadNum":
3,
"LoadNumOrd":
null,
"SupplierID":
6,
"Supplier":
"ESSO",
"CustomerID":
423,
"Customer":
"ESSO - MAC'S CONVENIENCE STORES INC. - CK",
"ShipTo":
null,
"LoadingNumber":
"313783 PO 852690",
"SpecialInstructions":
null,
"SentMailCounter":
4,
"WorkFlowCode":
"WF-SET-2",
"EventDescription":
"Loading Information;",
"NextLoadToActive":
0
},
}
             */
        }
    },
    data() {
        return {
            open: this.dialogStatus
        };
    },
    watch: {
        dialogStatus: function(val) {
            this.open = val;
        }
    },
    methods: {
        closeDialog() {
            this.open = false;
            this.$emit('update:dialogStatus', false);
        }
    }
};
</script>

<style scoped>
/* Your component's styles go here */
</style>
